import React, { useState, useEffect } from "react";
import "./ShopPage.css";
import { Link , useNavigate} from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../store/cartSlice';

const ShopPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedBrand, setSelectedBrand] = useState("All");
  const [maxPrice, setMaxPrice] = useState(5000);
  const [sortBy, setSortBy] = useState("default");
 const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  const dispatch = useDispatch();
  const { token } = useSelector(state => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const fetchFilteredData = async () => {
      setLoading(true);
      try {
        const queryParams = new URLSearchParams({
          search: searchQuery,
          category: selectedCategory, // Passes 'All' or numeric ID string (e.g. '3')
          brand: selectedBrand, // Passes 'All' or numeric ID string (e.g. '2')
          max_price: maxPrice.toString(),
          sort_by: sortBy,
        }).toString();
        
        console.log(queryParams);
        const response = await fetch(
          `https://rbuymart.rbhardwaj.com/server/api/products/fetch_filtered_products.php?${queryParams}`,
          { signal },
        );

        const result = await response.json();

        if (response.ok && result.status === "success") {
          setProducts(result.products || []);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Data pipeline broken:", error);
        }
      } finally {
        if (!signal.aborted) {
          setLoading(false);
        }
      }
    };

    const delayDebounceFn = setTimeout(() => {
      fetchFilteredData();
    }, 300);

    return () => {
      clearTimeout(delayDebounceFn);
      controller.abort();
    };
  }, [searchQuery, selectedCategory, selectedBrand, maxPrice, sortBy]);

    useEffect(() => {
      const fetchStorefrontData = async () => {
        try {
          const [categoriesRes, brandsRes] = await Promise.all([
            fetch(
              "https://rbuymart.rbhardwaj.com/server/api/products/categories.php"
            ),
           fetch(
              "https://rbuymart.rbhardwaj.com/server/api/products/brands.php"
            ),
            
          ]);
  const categoriesData = await categoriesRes.json();
    const brandsData = await brandsRes.json();
    console.log(brandsData.brands);
          setCategories(Array.isArray(categoriesData) ? categoriesData : []);
           setBrands(Array.isArray(brandsData.brands) ? brandsData.brands : []);
        } catch (err) {
      
        } finally {

        }
      };
  
      fetchStorefrontData();
    }, []);

  const handleAddToCartAction = (e, product) => {
    // ✅ FIXED: Prevent redirection to the product details page when clicking "Add to Cart"
    e.preventDefault();
    e.stopPropagation();

    if (!token) {
      // Trigger login modal via custom event channel mapped in Phase 6
      window.dispatchEvent(new CustomEvent('TRIGGER_AUTH_MODAL', { detail: { mode: 'login' } }));
      return;
    }

    let dynamicUserId = null;
    const userProfile = localStorage.getItem('user_profile');
    if (userProfile) {
      try {
        const parsed = JSON.parse(userProfile);
        dynamicUserId = parsed.id || parsed.user_id;
      } catch (err) {
        console.error("Failed to parse user profile context in ShopPage", err);
      }
    }
      
    // Dispatch structured line item payload to Redux cart logic layer
    dispatch(addToCart({
        user_id: dynamicUserId,
        product_id: product.id,
        variant_id: null,
        quantity: 1
    }));

    alert('Your item has been added to the cart');
    navigate('/cart');
  };


  return (
    <div className="shop-page-container">
      <div className="shop-layout-body">
        {/* 📌 SIDEBAR FILTERS CONTROLS */}
        <aside className="filter-sidebar-node">
          <h4>Filter By</h4>
           <div className="search-input">
  <i class="material-icons">&#xe8b6;</i>
          <input
            type="search"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input-field"
          />
</div>

  
          <hr />
         <div className="formlabeldiv">
     
        
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="sort-dropdown-select"
          >
               <option value="All">All Categories</option>
            {categories.map((cat) => (

               <option value={cat.id}>{cat.name}</option>
            ))};
            
          </select>
 <label>Categories</label>
         </div>
    

       <div className="formlabeldiv">
          <select
            value={selectedBrand}
            onChange={(e) => setSelectedBrand(e.target.value)}
            className="sort-dropdown-select"
          >
                 <option value="All">All Brands</option>
            {brands.map((brand) => (
              
              <option value={brand.id}>{brand.name}</option>
              
              ))}
       
           
       
          </select>
    <label>Brands</label>

       </div>



          <h4>Max Price: ₹{maxPrice}</h4>
          <input
            type="range"
            min="100"
            max="10000"
            step="100"
            value={maxPrice}
            onChange={(e) => setMaxPrice(Number(e.target.value))}
            className="price-range-slider"
          />

          <hr />

          <small>
            * Filter by Brand, Categories *</small>
            <hr />
        </aside>

     
        <div className="product-view-workspace">
          {loading ? (
            <div className="empty-state-card">
            loading...
            </div>
          ) : products.length === 0 ? (
            <div className="empty-state-card">
              ⚠️ No products found matching criteria.
            </div>
          ) : (
            <div className="products-grid-layout section-div">
              {products.map((product) => (
                // ✅ FIXED: Moved 'key' to outermost Link tag and wrapped safely
                <Link key={product.id} to={`/product/${product.slug}`} className="product-card-anchor">
                  <div className="product-card shadow-entry">
                      <sup class="price-parsent" style={{position:"absolute",left:"5px",top:'5px'}}>
                      <b>
                        {(
                    ((product.compare_at_price - product.price) /
                      product.compare_at_price) *
                    100
                  ).toFixed(0)}% 
                        </b>  
                        
                         <small> OFF</small></sup>
                    
                    
                    
                    <div className="product-media-canvas">
                      
                      {product.primary_image ? (
                        <img
                          src={`https://rbuymart.rbhardwaj.com/server/${product.primary_image}`}
                          alt={product.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        "📦"
                      )}
                    </div>
                    <div className="product-info-block">
                   
                      <div className="card-financial-footer-row">
                        <div>
                         
                          <div className="product-price-tag">
                            ₹{Number(product.price || 0).toLocaleString("en-IN")}
                          </div>
                          {/* ✅ FIXED: Safeguarded null values for compare_at_price */}
                          {product.compare_at_price && (
                            <div className="strike-original-price">
                              ₹{parseFloat(product.compare_at_price).toLocaleString('en-IN')}
                            </div>
                          )}
                         
                        </div>
                        
                        <button 
                          className="btn-add-to-cart-action-trigger"
                          disabled={product.stock === 0}
                          onClick={(e) => handleAddToCartAction(e, product)}
                        >
                           <i class="material-icons">&#xe8cc;</i>
                          {product.stock === 0 ? '' : ''}
                        </button>
                      </div>
                          <div class="pdp-rating">
          <div class="pdp-stars">
            <span class="star filled">★</span><span class="star filled">★</span
            ><span class="star filled">★</span><span class="star filled">★</span
            ><span class="star half">★</span>
          </div>
          <span class="pdp-review-count">(8765)</span>
        </div>
   <h3 className="product-display-name" title={product.name}>
                        {product.name}
                      </h3>

                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShopPage;